import { FC } from 'react';
import { Button, ButtonSizes, ButtonStyles } from '@silverfort/sf-components';
import { ModuleData } from './Types';

const DemoSuggestion: FC<{ module: ModuleData }> = ({ module }) => {
    return (
        <div className="flex font-sf px-[2.5vw] py-[3.8vh] justify-center content-center gap-[4.8vh] flex-col">
            <div className="flex gap-[1.9vh] text-sf-white flex-col">
                <div className="text-[2.6vh] font-light">{module.info.summary}</div>
                <div
                    className="text-[1.6vh] font-normal"
                    dangerouslySetInnerHTML={{ __html: module.info.description }}
                />
            </div>
            {module.info.url && (
                <Button
                    text="Request a Demo"
                    buttonStyle={ButtonStyles.GradientBackground}
                    buttonSize={ButtonSizes.Large}
                    className={'!rounded-[3.1vw]'}
                    onClick={() => window.open(module.info.url, '_blank')}
                />
            )}
        </div>
    );
};

export default DemoSuggestion;
